import { gql } from "apollo-boost";

/* 
 *  extend type Query {
 *    getChatrooms
 *      : [ChatRoom]
 *  }
 */

export const GET_CHATROOMS = gql`
  query getChatRooms {
    getChatRooms {
      id
    }
  }
`;

/* 
 *  extend type Query {
 *    getChatRoomsByFilter
 *      : [ChatRoom]
 *  }
 */


export const GET_CHATROOMS_BY_FILTER = gql`
  query getChatRoomsByFilter {
    getChatRoomsByFilter {
      id
    }
  }
`;

/* 
 *  extend type Query {
 *    getChatRoomById
 *      : ChatRoom
 *  }
 */

export const GET_CHATROOM_BY_ID = gql`
  query getChatRoomById ($id: ID!, $userUUID: String) {
    getChatRoomById (
      id: $id
      userUUID: $userUUID
    )
    {
      id
      chatMessageSet {
        id
        meta {
          date
          timestamp
          length
        }
        messages
        previousMessages
      }
      members
      activeUserList
    }
  }
`;

/* 
 *  extend type Query {
 *    getChatRoomByAssociativeKey
 *      : ChatRoom
 *  }
 */

export const GET_CHATROOM_BY_ASSOCIATIVE_KEY = gql`
  query getChatRoomByAssociativeKey (
    $associateFeatureInput: [ChatAssociateFeatureInput]!
  ) {
    getChatRoomByAssociativeKey (
      associateFeatureInput: $associateFeatureInput
    )
    {
      id
      chatMessageSet {
        id
        meta {
          date
          timestamp
          length
        }
        messages
        previousMessages
      }
      members
      activeUserList
    }  
  }
`;

/* 
 *  extend type Query {
 *    sendChatMessages
 *      : ChatRoom
 *  }
 */

export const SEND_CHATMESSAGES = gql`
  mutation sendChatMessages (
    $chatroomID: ID!
    $chatMessagesInput: [ChatMessageInput]!
  ) {
    sendChatMessages (
      chatroomID: $chatroomID,
      chatMessagesInput: $chatMessagesInput
    )
    {
      id
    }  
  }
`;
